import { render, staticRenderFns } from "./HeadImgUpload.vue?vue&type=template&id=3a189a8d&"
import script from "./HeadImgUpload.vue?vue&type=script&lang=js&"
export * from "./HeadImgUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports